<div class="row">
    <div class="col-lg-10">
        <h1>Dashboard</h1>
        <br>
    </div>
</div>
<div class="row">
    <div class="col-xl-3 col-lg-6">
        <app-stat [bgClass]="'card-primary'" [icon]="'fa fa-database'" [count]="totalApplications" [label]="'Total Applications'"
            [data]="applications"></app-stat>
    </div>
    <div class="col-xl-3 col-lg-6">
        <app-stat [bgClass]="'card-success'" [icon]="'fa fa-check'" [count]="succesfulAttempts" [label]="'Successful Attempts'"  [info]="applicationLogsInfoText" [data]="applicationLogs"></app-stat>
    </div>
    <div class="col-xl-3 col-lg-6">
        <app-stat [bgClass]="'card-danger'" [icon]="'fa fa-exclamation-triangle'" [count]="failedAttempts" [label]="'Failed Attempts'"  [info]="applicationLogsInfoText"
            [data]="applicationStats"></app-stat>
    </div>
    <div class="col-xl-3 col-lg-6">
        <app-stat [bgClass]="'card-info'" [icon]="'fa fa-user'" [count]="totalUsers" [label]="'Total Users'" [data]="applicationStats"></app-stat>
    </div>
</div>